import { TextInput, PasswordInput, Divider, Select } from '@mantine/core';
import { Alert, Box, Button, Card, CardContent, CardHeader, Stack, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { signInForUserAndEnv } from '../../services/authenticationService';
import { EnvironmentRegistry } from '../../services/registry/environmentRegistry';
import { openPopup } from '../../stateManagement/actions/popupActions';
import "./ConfigComparator.css"
import { isUndefinedorEmpty } from '../transformer/UnregisteredFunctions';


interface ConfigCompareLoginProps {
    
      setSelectedEnv: React.Dispatch<React.SetStateAction<string>>;
      selectedEnv: string;
      setSelectedEntity: () => void;

  }
export default function ConfigCompareLogin(props: ConfigCompareLoginProps)
     

   {
    const homeEnv = localStorage.getItem("env");

    const tokenRegistry = EnvironmentRegistry.tokenRegistry;
    const envList: string[] = Object.keys(tokenRegistry);
    const [selectedEnv, setSelectedEnv] = useState<string>("demo");
    const onSuccess = () => setSelectedEnv("none");
    const [lobList, setLobList] = useState<string[]>([]);
    
    useEffect(() => {
        props.selectedEnv !=='none' && EnvironmentRegistry.getLobs(props.selectedEnv)
            .then((res)=>setLobList(res.sort((a,b)=>a.localeCompare(b))))
            .catch((err)=>{
                console.error(err);
                setLobList([]);
        });
    }, [props.selectedEnv]);
    

    return ( 
        <Box className='config-compare-container'>
            <Box className="config-compare-env-container">
                {envList.map(env => (
                    <Button key={env}
                        disableRipple 
                        className={
                        ` config-compare-base-card 
                          config-compare-base-card-${isUndefinedorEmpty(tokenRegistry[env]) ? 'failure' : 'success'}
                          ${env===props.selectedEnv && 'config-compare-base-card-active'}
                        `} 
                        onClick={() => props.setSelectedEnv(prevenv=>prevenv==='none'|| prevenv!==env ? env:'none')}
                    >
                        <Typography variant='subtitle2' color='black'>{env}</Typography>
                    </Button>
                ))}
            </Box>
           
{props.selectedEnv !== homeEnv && (
  <Box className="config-compare-login-container">
    {props.selectedEnv === 'none' ? (
      <Alert severity="info" variant="outlined">
        Select Environment to login
      </Alert>
    ) : isUndefinedorEmpty(tokenRegistry[props.selectedEnv]) ? (
      <div className='centered-container'>
        <Typography variant="subtitle2" color="black">
            Select LOB to compare and enter credentials
        </Typography>
        <LoginForm
          env={props.selectedEnv}
          onSuccess={onSuccess}
          setSelectedEntity={props.setSelectedEntity}
          envList={envList}
          lobList={lobList}
        />
      </div>
    ) : (
      <AlreadyLoggedInCard />
    )}
  </Box>
)}

{props.selectedEnv === homeEnv && (
<>
<Typography variant="subtitle2" color="black">
Select LOB to compare and enter credentials

 </Typography>
 <Box className="config-compare-login-container">
<LoginForm env={props.selectedEnv}  onSuccess={onSuccess} setSelectedEntity={props.setSelectedEntity} envList={envList} lobList={lobList} />
</Box>
</>                           

    )}
</Box>
       
    );
}




const AlreadyLoggedInCard = () => {
    return (
        <Card className='AlreadyLoggedInCard' raised >
            <CardHeader title="Logged In" />
            <CardContent>
                <p>You are already logged in.</p>
            </CardContent>
        </Card>
    )
};


function LoginForm(props: { env: string, lobList:string[] ,onSuccess:()=>void, setSelectedEntity:()=>void,envList:string[]}) {
    const userNameInput = useRef<HTMLInputElement>(null);
    const lobInput = useRef<HTMLInputElement>(null);
    const passwordInput = useRef<HTMLInputElement>(null);
    const homeEnv = localStorage.getItem("env");

    const handleLogin = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        const userName: string = userNameInput.current?.value!;
        const password: string = passwordInput.current?.value!;
        const lob: string = lobInput.current?.value!;
        if (!lob) {
            openPopup("Error", "LOB field cannot be blank");
        }
        else if (!userName) {
            openPopup("Error", "Username field cannot be blank");
        }
        else if (!password) {
            openPopup("Error", "Password field cannot be blank");
        }
        else if (userName && password && lob) {
            try {
                const loginResponse = await signInForUserAndEnv(userName, password, lob, props.env || "");
                
                if (loginResponse.status === 200 && props.env!==homeEnv) {
                    localStorage.setItem(`${props.env}lob`,loginResponse.data.user.lob);
                    localStorage.removeItem("compareLobAccessToken");
                    localStorage.removeItem("compareLobName");

                    EnvironmentRegistry.setToken(props.env, loginResponse.data.token);
                    openPopup("Success", "Successfully Logged In");
                    props.onSuccess();
                    props.setSelectedEntity()
                } 
                else if(loginResponse.status===200 && props.env==homeEnv){
                     localStorage.setItem("compareLobAccessToken",loginResponse.data.token);
                     localStorage.setItem("compareLobName",loginResponse.data.user.lob);
                     for (const env of props.envList) {
                        if (env !== homeEnv) {
                          EnvironmentRegistry.setToken(env, ""); 
                        }
                      }
                      
                      props.onSuccess();
                      openPopup("Success", "Successfully Logged In");
                      props.setSelectedEntity();
                }
                else {
                    openPopup("Error", "Incorrect Credentials");
                }
            } catch (error) {
                openPopup("Error", "Incorrect Credentials");
            }
        } else {
            openPopup("Error", "Incorrect Credentials");
        }
    }

    return (
        <Stack width={"100%"} spacing={2}>
            <Select zIndex={10000} searchable  id='lobInput' placeholder='Lob' ref={lobInput} data={props.lobList} />
            <TextInput id='usernameInput' placeholder='User Name' ref={userNameInput} />
            <PasswordInput id='passwordInput' placeholder='Password' ref={passwordInput}/>
            <Button variant='contained' type="submit" onClick={handleLogin}>LOGIN</Button>
        </Stack>
    )
}